// Copyright (c) 2017 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import criteria from './criteria';
import gridApi from './create-grid-api';
import report from './report';
import reportIsScrollable from './report-is-scrollable';
import showNoResultsFound from './show-no-results-found';

export const getCombinedReducers = () =>
    combineReducers({
        busyCounter,
        criteria,
        gridApi,
        report,
        reportIsScrollable,
        showNoResultsFound
    });



// WEBPACK FOOTER //
// ./src/reports/pip-history/reducers/index.js